import accordionTabs from '@scripts/components/accordion-tabs'

accordionTabs.init()
